import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { LoginPage } from './pages/LoginPage';
import { WeChatCallbackPage } from './pages/WeChatCallbackPage';
import { WorkflowEditorPage } from './pages/WorkflowEditorPage';
import { WorkflowManagementPage } from './pages/WorkflowManagementPage';
import { RuleManagementPage } from './pages/RuleManagementPage';
import { DataManagementPage } from './pages/DataManagementPage';
import { SettingsPage } from './pages/SettingsPage';
import { LicensePage } from './pages/LicensePage';
import { UpgradePage } from './pages/UpgradePage';
import { FeedbackPage } from './pages/FeedbackPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { MainLayout } from './components/layout/MainLayout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/wechat-callback" element={<WeChatCallbackPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/home" replace />} />
          <Route path="home" element={<WorkflowEditorPage />} />
          <Route path="workflows" element={<WorkflowManagementPage />} />
          <Route path="workflows/edit/:workflowId" element={<WorkflowEditorPage />} />
          <Route path="rules" element={<RuleManagementPage />} />
          <Route path="data" element={<DataManagementPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="upgrade" element={<UpgradePage />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="users" element={<UserManagementPage />} />
          <Route path="license" element={<LicensePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
